import { render } from "./private.vue?vue&type=template&id=37f79544&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"

import "./private.vue?vue&type=style&index=0&id=37f79544&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f79544"]])

export default __exports__